var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-post"},[_c(_vm.view,{tag:"component"}),_c('Comments',{attrs:{"comments":_vm.reversedComments,"pageId":_vm.pageId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }